// Apply an Op to a local MatrixState. The client trusts its own ops
// (the server validates and rejects on bad ones); this function does
// the mutation only. Mirrors the *successful* branches of
// core/src/ops.rs `apply`.

import type { MatrixState } from "../generated/MatrixState";
import type { Op } from "../generated/Op";
import type { Task } from "../generated/Task";

export function applyOp(state: MatrixState, op: Op): void {
  switch (op.type) {
    case "add": {
      const t: Task = {
        label: op.task.label.trim(),
        dueDate: op.task.dueDate,
        quadrant: op.task.quadrant,
        rank: op.task.rank,
      };
      state.tasks[op.task.id] = t;
      return;
    }
    case "update": {
      const t = state.tasks[op.id];
      if (!t) return;
      if (op.patch.label !== undefined && op.patch.label !== null) {
        t.label = op.patch.label.trim();
      }
      if (op.patch.dueDate !== undefined) {
        t.dueDate = op.patch.dueDate;
      }
      if (op.patch.completedAt !== undefined) {
        t.completedAt = op.patch.completedAt ?? undefined;
      }
      return;
    }
    case "delete": {
      delete state.tasks[op.id];
      return;
    }
    case "move": {
      const t = state.tasks[op.id];
      if (!t) return;
      t.quadrant = op.quadrant;
      t.rank = op.rank;
      return;
    }
    case "settings": {
      state.settings = op.settings;
      return;
    }
    case "title": {
      const t = op.title?.trim();
      state.title = t ? t : undefined;
      return;
    }
  }
}
